/*
 * BONVAYANA v2 · capa de marca sobre Horizon
 * <bv-chat>    conversaciones con "kirjoittaa…" (portada, FAQ, newsletter, popup, tallas)
 * <bv-popup>   chat modal: escribe, envía y recibe −10 %
 * <bv-pill>    píldora flotante con la oferta por volumen
 * <bv-toasts>  reacciones al añadir al carrito
 * <bv-add>     añadir sin salir (carrito y ficha) y refrescar el carrito
 * <bv-size>    asistente de tallas en la ficha
 * <bv-eta>     fecha estimada de entrega
 */

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const beat = (ms) => new Promise((r) => setTimeout(r, reduceMotion ? 0 : ms));
const typingTime = (t) => Math.min(1500, 420 + String(t || '').trim().length * 15);
const pad = (n) => String(n).padStart(2, '0');
const hhmm = () => { const d = new Date(); return `${pad(d.getHours())}:${pad(d.getMinutes())}`; };
const store = (k) => ({
  get: (key) => { try { return window[k].getItem(key); } catch (e) { return null; } },
  set: (key, v) => { try { window[k].setItem(key, v); } catch (e) { /* bloqueado */ } },
});
const session = store('sessionStorage');
const local = store('localStorage');
const root = (window.BV && window.BV.root) || '/';
const url = (p) => (root.endsWith('/') ? root : root + '/') + p.replace(/^\//, '');

let SE = null;
try { SE = await import('@shopify/events'); } catch (e) { SE = null; }
let morph = null;
try { morph = (await import('@theme/section-renderer')).morphSection; } catch (e) { morph = null; }

function dots() {
  const el = document.createElement('div');
  el.className = 'bv-typing';
  el.setAttribute('aria-hidden', 'true');
  el.innerHTML = '<i></i><i></i><i></i>';
  return el;
}
function msg(side, html, isText, extra) {
  const el = document.createElement('div');
  el.className = `bv-msg${side === 'out' ? ' bv-msg--out' : ''}${extra ? ' ' + extra : ''} bv-new`;
  if (isText) el.textContent = html; else el.innerHTML = html;
  return el;
}
async function sayAfter(anchor, node, onTyping) {
  const d = dots();
  anchor.after(d);
  onTyping?.(true);
  scrollLog(d);
  await beat(typingTime(node.textContent));
  d.replaceWith(node);
  onTyping?.(false);
  scrollLog(node);
  return node;
}
function scrollLog(el) {
  const log = el.closest('.bv-chat__log');
  if (log && log.scrollHeight > log.clientHeight + 4) log.scrollTo({ top: log.scrollHeight, behavior: reduceMotion ? 'auto' : 'smooth' });
}
function fillTokens(scope) {
  scope.querySelectorAll('[data-bv-time]').forEach((t) => (t.textContent = hhmm()));
  scope.querySelectorAll('[data-bv-tpl]').forEach((el) => {
    el.innerHTML = el.innerHTML.replaceAll('{time}', hhmm());
  });
}
document.addEventListener('click', (e) => {
  const c = e.target.closest?.('.bv-code');
  if (!c) return;
  const code = c.dataset.code;
  const small = c.querySelector('small');
  navigator.clipboard?.writeText(code).then(() => {
    if (small) { const t = small.textContent; small.textContent = 'kopioitu ✓'; setTimeout(() => (small.textContent = t), 1600); }
  }, () => {});
});
function openDrawer() {
  const d = document.querySelector('theme-drawer#cart-drawer');
  try { d?.open?.(); } catch (e) { /* sin drawer */ }
}

/* ------------------------------------------------------------------ */
/* Suscripción: crea el cliente con marketing y enseña el código       */
/* ------------------------------------------------------------------ */
function setupMail(form, onDone) {
  if (!form || form.dataset.ready) return;
  form.dataset.ready = '1';
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.sending) return;
    const input = form.querySelector('input[type="email"]');
    const button = form.querySelector('button');
    const wrap = form.closest('[data-bv-mailwrap]') || form;
    const err = wrap.querySelector('.bv-err');
    const email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      if (err) { err.textContent = 'tarkistatko vielä sähköpostin? 🙂'; err.hidden = false; }
      input.focus();
      return;
    }
    form.dataset.sending = '1';
    button.disabled = true;
    fetch(form.action || url('contact'), { method: 'POST', body: new URLSearchParams(new FormData(form)), headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).catch(() => {});
    local.set('bv_sub', '1');
    try { window.fbq?.('track', 'Lead', { content_name: 'Bonvayana -10%' }); } catch (e) { /* sin pixel */ }
    const out = msg('out', email.replace(/^(.).*(@.*)$/, '$1•••$2'), true);
    wrap.replaceWith(out);
    const code = (window.BV && window.BV.code) || 'TERVETULOA10';
    let last = await sayAfter(out, msg('in', 'kiitos! tässä koodisi. se toimii ensimmäiseen tilaukseen:'));
    last = await sayAfter(last, msg('in', `<button type="button" class="bv-code" data-code="${code}">${code} <small>kopioi</small></button>`));
    last = await sayAfter(last, msg('in', 'liitä se kassalla. ja hei, kiva kun löysit meidät. 🤍'));
    onDone?.(last);
  }, true);
}

/* ------------------------------------------------------------------ */
/* <bv-chat>                                                           */
/* ------------------------------------------------------------------ */
class BvChat extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = '1';
    fillTokens(this);
    this.log = this.querySelector(':scope .bv-chat__log');
    this.status = this.querySelector('[data-bv-status]');
    this.querySelectorAll('form[data-bv-mail]').forEach((f) => setupMail(f));
    if (!this.log) return;
    this.items = [...this.log.querySelectorAll(':scope > [data-bv-msg]')];
    const key = `bv-chat-${this.dataset.key || 'x'}`;
    const once = this.dataset.once !== '0';
    const can = this.dataset.animate === '1' && !reduceMotion && 'IntersectionObserver' in window && !(once && session.get(key));
    if (!can) { this.items.forEach((i) => i.classList.add('is-shown')); return; }
    this.key = key;
    this.classList.add('is-waiting');
    if (this.dataset.manual === '1') return;
    this.io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      this.io.disconnect();
      this.play();
    }, { threshold: 0.15 });
    this.io.observe(this);
  }
  disconnectedCallback() { this.io?.disconnect(); this.stopped = true; }
  setTyping(on) {
    if (!this.status) return;
    if (!this.status.dataset.base) this.status.dataset.base = this.status.textContent;
    this.status.textContent = on ? 'kirjoittaa…' : this.status.dataset.base;
    this.status.classList.toggle('is-typing', on);
  }
  async play() {
    if (this.playing) return;
    this.playing = true;
    session.set(this.key, '1');
    this.classList.remove('is-waiting');
    this.classList.add('is-playing');
    const d = dots();
    await beat(250);
    for (const item of this.items) {
      if (this.stopped) return;
      const kind = item.dataset.bvMsg;
      if (kind === 'in') {
        this.log.insertBefore(d, item);
        this.setTyping(true);
        scrollLog(d);
        await beat(typingTime(item.textContent));
        d.remove();
        this.setTyping(false);
      } else if (kind === 'out') {
        await beat(500);
      }
      item.classList.add('is-shown', 'bv-new');
      scrollLog(item);
      await beat(kind === 'in' ? 260 : 380);
    }
    this.classList.remove('is-playing');
    this.dispatchEvent(new CustomEvent('bv:done'));
  }
}

/* ------------------------------------------------------------------ */
/* <bv-popup>: "vastaa jotain" → −10 %                                 */
/* ------------------------------------------------------------------ */
class BvPopup extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = '1';
    if (local.get('bv_sub')) return;
    const closedAt = Number(local.get('bv_pop_closed') || 0);
    if (Date.now() - closedAt < 3 * 24 * 3600 * 1000 || session.get('bv_pop_seen')) return;
    this.chat = this.querySelector('bv-chat');
    this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.close()));
    this.addEventListener('click', (e) => { if (e.target === this) this.close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.hidden) this.close(); });
    const form = this.querySelector('form[data-bv-reply]');
    form?.addEventListener('submit', (e) => { e.preventDefault(); this.reply(form); });
    const show = () => {
      if (this.shown) return;
      if (document.querySelector('dialog[open]')) { setTimeout(show, 4000); return; }
      this.shown = true;
      window.removeEventListener('scroll', onScroll);
      session.set('bv_pop_seen', '1');
      this.hidden = false;
      this.chat?.play?.();
    };
    const onScroll = () => { if (window.scrollY > (document.documentElement.scrollHeight - innerHeight) * 0.45) show(); };
    setTimeout(show, Number(this.dataset.delay || 12000));
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  close() {
    local.set('bv_pop_closed', String(Date.now()));
    this.hidden = true;
  }
  async reply(form) {
    if (form.dataset.done) return;
    form.dataset.done = '1';
    const text = form.querySelector('input').value.trim() || 'joo.';
    const box = form.closest('[data-bv-msg]') || form;
    this.querySelector('.bv-pop__hint')?.remove();
    const out = msg('out', text, true);
    box.replaceWith(out);
    let last = await sayAfter(out, msg('in', 'tiesin. 😊'));
    last = await sayAfter(last, msg('in', 'pieni tervetuliaislahja: <b>−10 %</b> ensimmäisestä tilauksestasi.'));
    last = await sayAfter(last, msg('in', 'mihin sähköpostiin lähetän koodin?'));
    const frag = this.querySelector('template[data-mail]').content.cloneNode(true);
    const wrap = frag.querySelector('[data-bv-mailwrap]');
    wrap.classList.add('bv-new');
    last.after(wrap);
    setupMail(wrap.querySelector('form'));
    scrollLog(wrap);
    wrap.querySelector('input')?.focus({ preventScroll: true });
  }
}

/* ------------------------------------------------------------------ */
/* <bv-pill>                                                           */
/* ------------------------------------------------------------------ */
class BvPill extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = '1';
    const btn = this.querySelector('.bv-pill__btn');
    const card = this.querySelector('.bv-pill__card');
    btn?.addEventListener('click', () => { card.hidden = !card.hidden; btn.setAttribute('aria-expanded', String(!card.hidden)); });
    document.addEventListener('click', (e) => { if (!this.contains(e.target) && card && !card.hidden) { card.hidden = true; btn.setAttribute('aria-expanded', 'false'); } });
  }
}

/* ------------------------------------------------------------------ */
/* <bv-toasts>: cualquier añadido (fetch /cart/add) da una reacción    */
/* ------------------------------------------------------------------ */
class BvToasts extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = '1';
    this.timers = [];
    this.lines = [this.dataset.l1, this.dataset.l2, this.dataset.l3].filter(Boolean);
    if (!this.lines.length || window.__bvFetchWrapped) return;
    window.__bvFetchWrapped = true;
    const original = window.fetch.bind(window);
    window.fetch = (...args) => {
      const p = original(...args);
      try {
        const [input, init] = args;
        const href = typeof input === 'string' ? input : input?.url || '';
        const method = (init?.method || input?.method || 'GET').toUpperCase();
        if (method === 'POST' && /\/cart\/add/.test(href)) p.then((r) => { if (r.ok) this.queue(); }).catch(() => {});
      } catch (e) { /* nunca romper el fetch del tema */ }
      return p;
    };
  }
  queue() {
    clearTimeout(this.wait);
    this.wait = setTimeout(() => this.afterAdd(), 600);
  }
  async afterAdd() {
    try {
      const cart = await fetch(url('cart.js'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const n = cart.item_count || 1;
      this.show(this.lines[Math.min(n, this.lines.length) - 1].split('|'));
    } catch (e) { /* sin toast */ }
  }
  show(parts) {
    this.timers.forEach(clearTimeout);
    this.timers = [];
    this.innerHTML = '';
    const host = document.querySelector('dialog[open]') || document.body;
    if (this.parentElement !== host) host.append(this);
    parts.forEach((text, i) => {
      this.timers.push(setTimeout(() => {
        const t = document.createElement('div');
        t.className = 'bv-toast';
        t.innerHTML = '<span class="bv-av" aria-hidden="true">B</span>';
        t.append(msg('in', text.trim(), true));
        t.addEventListener('click', () => this.hide());
        this.append(t);
      }, reduceMotion ? 0 : 250 + i * 1000));
    });
    this.timers.push(setTimeout(() => this.hide(), 250 + parts.length * 1000 + 3400));
  }
  hide() {
    this.querySelectorAll('.bv-toast').forEach((t) => t.classList.add('is-out'));
    this.timers.push(setTimeout(() => (this.innerHTML = ''), 380));
  }
}

/* ------------------------------------------------------------------ */
/* <bv-add>: añade una variante y refresca el carrito lateral           */
/* ------------------------------------------------------------------ */
async function addToCart(id, quantity = 1) {
  const section = 'cart-drawer-section';
  let deferred = null;
  try {
    if (SE?.CartLinesUpdateEvent?.createPromise) {
      deferred = SE.CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new SE.CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: [{ id: String(id), quantity }], promise: deferred.promise }));
    }
  } catch (e) { deferred = null; }
  try {
    const res = await fetch((window.BV && window.BV.cartAdd) || url('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity }], sections: section, sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || 'add failed');
    const cart = await fetch(url('cart.js'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
    if (deferred) {
      deferred.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { sections: data.sections, items: cart.items, itemCount: cart.item_count, source: 'bv-add', didError: false } });
    } else if (morph && data.sections?.[section]) {
      await morph(section, data.sections[section], { mode: 'hydration' });
    }
    return true;
  } catch (e) {
    deferred?.reject(e);
    throw e;
  }
}
class BvAdd extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = '1';
    this.addEventListener('submit', async (event) => {
      const form = event.target.closest('form');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button');
      const id = Number(new FormData(form).get('id'));
      if (!id || button.disabled) return;
      button.disabled = true;
      const label = button.innerHTML;
      button.innerHTML = '…';
      try {
        await addToCart(id, 1);
        button.classList.add('is-ok');
        button.innerHTML = '✓';
        if (this.dataset.open === '1') openDrawer();
        setTimeout(() => { if (button.isConnected) { button.disabled = false; button.classList.remove('is-ok'); button.innerHTML = label; } }, 1800);
      } catch (e) {
        button.disabled = false;
        button.innerHTML = label;
      }
    });
  }
}

/* ------------------------------------------------------------------ */
/* <bv-size>: asistente de tallas                                      */
/* ------------------------------------------------------------------ */
class BvSize extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = '1';
    try { this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch (e) { this.data = null; }
    this.btn = this.querySelector('.bv-ask');
    this.panel = this.querySelector('.bv-ask__panel');
    this.log = this.querySelector('.bv-chat__log');
    if (!this.data || !this.data.values?.length) { this.hidden = true; return; }
    this.btn.addEventListener('click', () => {
      const open = this.panel.hidden;
      this.panel.hidden = !open;
      this.btn.setAttribute('aria-expanded', String(open));
      if (open && !this.log.childElementCount) this.start();
    });
  }
  async say(html) {
    const d = dots();
    this.log.append(d);
    await beat(typingTime(html.replace(/<[^>]+>/g, '')));
    const m = msg('in', html);
    d.replaceWith(m);
    await beat(200);
    return m;
  }
  ask(options) {
    return new Promise((resolve) => {
      const box = document.createElement('div');
      box.className = 'bv-chips bv-new';
      options.forEach(([label, value]) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'bv-chip';
        b.textContent = label;
        b.addEventListener('click', () => { box.replaceWith(msg('out', label, true)); resolve(value); });
        box.append(b);
      });
      this.log.append(box);
    });
  }
  async start() {
    const { values, shoe } = this.data;
    if (shoe) {
      await this.say('autan hetkessä. mikä kengänkoko sinulla yleensä on?');
      const v = await this.ask(values.map((x) => [x, x]));
      await this.say(`nämä ovat normaalia lestikokoa, joten <b>${v}</b> on oikea valinta. jos olet puolikkaan koon välissä, ota isompi.`);
      return this.finish(v);
    }
    await this.say('autan hetkessä. mikä koko sinulla on yleensä?');
    const base = await this.ask(values.map((x) => [x, x]));
    await this.say('ja miten tykkäät, että vaate istuu?');
    const fit = await this.ask([['väljästi', 1], ['normaalisti', 0], ['vartalonmyötäisesti', 0]]);
    let i = values.indexOf(base) + fit;
    if (i >= values.length) i = values.length - 1;
    const rec = values[i];
    await this.say(rec === base ? `valitse <b>${rec}</b>. tämä malli on normaalikokoinen.` : `ota <b>${rec}</b>. yksi koko isompi antaa juuri sen väljyyden, josta tykkäät.`);
    return this.finish(rec);
  }
  async finish(value) {
    const scope = this.closest('.shopify-section') || document;
    const input = [...scope.querySelectorAll('variant-picker input[type="radio"], .variant-picker input[type="radio"]')].find((el) => el.value === value);
    if (input) {
      input.click();
      await this.say('merkitsin sen sinulle valmiiksi. 👆');
    }
    const next = await this.ask([['lisää ostoskassiin', 'add'], ['kiitos, katselen vielä', 'no']]);
    if (next === 'add') {
      for (let n = 0; n < 30; n++) {
        const add = scope.querySelector('button[name="add"], .add-to-cart-button');
        if (add && !add.disabled) { add.click(); break; }
        await new Promise((r) => setTimeout(r, 100));
      }
    } else {
      await this.say('ole hyvä! täällä ollaan, jos tulee kysyttävää.');
    }
  }
}

/* ------------------------------------------------------------------ */
/* <bv-eta>                                                            */
/* ------------------------------------------------------------------ */
function addBusinessDays(date, days) {
  const d = new Date(date);
  let added = 0;
  while (added < days) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) added++; }
  return d;
}
class BvEta extends HTMLElement {
  connectedCallback() {
    const f = new Intl.DateTimeFormat('fi-FI', { day: 'numeric', month: 'numeric' });
    const w = new Intl.DateTimeFormat('fi-FI', { weekday: 'short' });
    const a = addBusinessDays(new Date(), Number(this.dataset.min || 7));
    const b = addBusinessDays(new Date(), Number(this.dataset.max || 12));
    const out = this.querySelector('[data-eta]');
    if (out) out.textContent = `${w.format(a)} ${f.format(a)} – ${w.format(b)} ${f.format(b)}`;
  }
}

/* Aparición suave */
if ('IntersectionObserver' in window) {
  const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: 0.12 });
  const scan = () => document.querySelectorAll('.bv-reveal:not(.is-in), .bv-big:not(.is-in)').forEach((el) => io.observe(el));
  scan();
  document.addEventListener('shopify:section:load', scan);
} else {
  document.querySelectorAll('.bv-reveal, .bv-big').forEach((el) => el.classList.add('is-in'));
}

const define = (n, c) => { if (!customElements.get(n)) customElements.define(n, c); };
define('bv-chat', BvChat);
define('bv-popup', BvPopup);
define('bv-pill', BvPill);
define('bv-toasts', BvToasts);
define('bv-add', BvAdd);
define('bv-size', BvSize);
define('bv-eta', BvEta);
